export const PRICING_CATALOG_OFFERS_QUERY_KEY = ['pricingCatalogOffers'] as const;
export const PRICING_CATALOG_ACQUISITION_QUERY_KEY = ['pricingCatalogAcquisition'] as const;
// Prefix of every feature: the hook appends `[feature, userId]`, so `[...KEY, feature]` invalidates one feature.
export const UPGRADE_OFFERS_QUERY_KEY = ['upgradeOffers'] as const;
